/** International Space Station (ZARYA). */
export const ISS_NORAD_ID = '25544';
